module.exports = __webpack_public_path__ + "static/img/banner02.c148d1fd.png";